function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin, Messaging } from 'oskari-ui/util';
import { showFeatureDataFlyout } from '../view/FeatureDataFlyout';
import { showSelectByPropertiesPopup } from '../view/SelectByProperties';
import { COLUMN_SELECTION, FILETYPES, SEPARATORS, showExportDataPopup } from '../view/ExportData';
import { FEATUREDATA_BUNDLE_ID } from '../view/FeatureDataContainer';
import { filterFeaturesByPropertyFilter } from '../../../mapping/mapmodule/oskariStyle/filter';
import { cleanFilter } from 'oskari-ui/components/FeatureFilter';
export var ID_FIELD = '__fid';
export var ID_FIELD_LABEL = 'ID';
export var SELECTION_SERVICE_CLASSNAME = 'Oskari.mapframework.service.VectorFeatureSelectionService';
var EXPORT_FEATUREDATA_ROUTE = 'ExportTableFile';
var EXPORT_FEATUREDATA_EXCEL_MAX_LENGTH = 120000;
var FeatureDataPluginUIHandler = /*#__PURE__*/function (_StateHandler) {
  function FeatureDataPluginUIHandler(mapModule) {
    var _this;
    _classCallCheck(this, FeatureDataPluginUIHandler);
    _this = _callSuper(this, FeatureDataPluginUIHandler);
    _this.mapModule = mapModule;
    _this.setState(_this.initState());
    _this.selectionService = mapModule.getSandbox().getService(SELECTION_SERVICE_CLASSNAME);
    _this.flyoutController = null;
    _this.selectByPropertiespopupController = null;
    _this.addStateListener(function () {
      return _this.updateFlyout();
    });
    return _this;
  }
  _inherits(FeatureDataPluginUIHandler, _StateHandler);
  return _createClass(FeatureDataPluginUIHandler, [{
    key: "initState",
    value: function initState() {
      var featureDataLayers = this.getFeatureDataLayers() || [];
      var activeLayerId = this.determineActiveLayerId(featureDataLayers);
      return {
        activeLayerId: activeLayerId,
        layers: featureDataLayers,
        flyoutOpen: false,
        activeLayerFeatures: null,
        showSelectedFirst: false,
        showCompressed: true,
        loadingStatus: {},
        visibleColumnsSettings: {
          allColumns: [],
          visibleColumns: []
        },
        selectByPropertiesFilter: {},
        selectByPropertiesFeatureTypes: {}
      };
    }
  }, {
    key: "getFeatureDataLayers",
    value: function getFeatureDataLayers() {
      return this.mapModule.getSandbox().findAllSelectedMapLayers().filter(function (layer) {
        return layer.isVisibleOnMap() && layer.hasFeatureData && layer.hasFeatureData();
      });
    }
  }, {
    key: "getFeaturesByLayerId",
    value: function getFeaturesByLayerId(layerId) {
      var featuresMap = this.mapModule.getVectorFeatures(null, {
        layers: [layerId]
      });
      return featuresMap && featuresMap[layerId] ? featuresMap[layerId].features : null;
    }
  }, {
    key: "getSelectedFeatureIdsByLayerId",
    value: function getSelectedFeatureIdsByLayerId(layerId) {
      if (!this.selectionService) {
        return [];
      }
      return this.selectionService.getSelectedFeatureIdsByLayer(layerId);
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(layerId) {
      // when clicking on a tab directly, layerId will be a number.
      // When clicked in the "show more" menu of the tablist, it will be a String and no features are found.
      // so we gotta make a conversion for a numeric layerid just in case. :(
      if (Oskari.util.isNumber(layerId)) {
        layerId = +layerId;
      }
      var features = layerId ? this.getFeaturesByLayerId(layerId) : null;
      var selectedFeatureIds = layerId ? this.getSelectedFeatureIdsByLayerId(layerId) : null;
      var visibleColumnsSettings = features && features.length ? this.createVisibleColumnsSettings(layerId) : null;
      this.updateState({
        activeLayerId: layerId,
        activeLayerFeatures: features,
        selectedFeatureIds: selectedFeatureIds,
        visibleColumnsSettings: visibleColumnsSettings,
        selectByPropertiesFilter: {},
        selectByPropertiesFeatureTypes: this.createSelectByPropertiesFeatureTypes(visibleColumnsSettings),
        sorting: this.determineSortingColumn(layerId)
      });
    }
  }, {
    key: "toggleShowSelectedFirst",
    value: function toggleShowSelectedFirst() {
      var _this$getState = this.getState(),
        activeLayerId = _this$getState.activeLayerId,
        sorting = _this$getState.sorting;
      var newState = {
        showSelectedFirst: !this.getState().showSelectedFirst
      };
      if (newState.showSelectedFirst && !(sorting !== null && sorting !== void 0 && sorting.order)) {
        newState.sorting = this.determineSortingColumn(activeLayerId);
      }
      this.updateState(newState);
    }
  }, {
    key: "toggleShowCompressed",
    value: function toggleShowCompressed() {
      var _this$getState2 = this.getState(),
        showCompressed = _this$getState2.showCompressed;
      this.updateState({
        showCompressed: !showCompressed
      });
    }
  }, {
    key: "updateStateAfterMapEvent",
    value: function updateStateAfterMapEvent() {
      this.updateState(this.prepareFeaturesAndColumnSettingsForState());
    }
  }, {
    key: "prepareFeaturesAndColumnSettingsForState",
    value: function prepareFeaturesAndColumnSettingsForState() {
      var featureDataLayers = this.getFeatureDataLayers() || [];
      if (!featureDataLayers || !featureDataLayers.length) {
        this.closeFlyout(true);
        return this.initState();
      }
      var newActiveLayerId = this.determineActiveLayerId(featureDataLayers);
      var activeLayerFeatures = null;
      var selectedFeatureIds = null;
      var visibleColumnsSettings = null;
      if (newActiveLayerId && this.getState().flyoutOpen) {
        activeLayerFeatures = this.getFeaturesByLayerId(newActiveLayerId);
        selectedFeatureIds = activeLayerFeatures && activeLayerFeatures.length ? this.getSelectedFeatureIdsByLayerId(newActiveLayerId) : null;
        visibleColumnsSettings = this.createVisibleColumnsSettings(newActiveLayerId);
      }
      ;
      var sorting = this.determineSortingColumn(newActiveLayerId);
      return {
        activeLayerId: newActiveLayerId,
        layers: featureDataLayers,
        activeLayerFeatures: activeLayerFeatures,
        selectedFeatureIds: selectedFeatureIds,
        visibleColumnsSettings: visibleColumnsSettings,
        sorting: sorting
      };
    }
  }, {
    key: "updateSelectedFeatures",
    value: function updateSelectedFeatures(layerId, selectedFeatureIds) {
      if (layerId === this.getState().activeLayerId) {
        this.updateState({
          selectedFeatureIds: selectedFeatureIds
        });
      }
    }
  }, {
    key: "updateSorting",
    value: function updateSorting(sorting) {
      // if show selected first - is checked but sorting is cancelled we need to set default sorting to keep the selected items first.
      var newState = {
        sorting: sorting
      };
      var _this$getState3 = this.getState(),
        showSelectedFirst = _this$getState3.showSelectedFirst,
        activeLayerId = _this$getState3.activeLayerId;
      if (showSelectedFirst && !sorting.order) {
        newState.sorting = this.determineSortingColumn(activeLayerId);
      }
      this.updateState(newState);
    }
  }, {
    key: "updateLoadingStatus",
    value: function updateLoadingStatus(loadingStatus, updateFeaturesAndColumns) {
      if (!updateFeaturesAndColumns) {
        this.updateState({
          loadingStatus: loadingStatus
        });
        return;
      }
      var featuresAndColumnSettings = this.prepareFeaturesAndColumnSettingsForState();
      this.updateState(_objectSpread({
        loadingStatus: loadingStatus
      }, featuresAndColumnSettings));
    }
  }, {
    key: "updateVisibleColumns",
    value: function updateVisibleColumns(value) {
      var _this$getState4 = this.getState(),
        visibleColumnsSettings = _this$getState4.visibleColumnsSettings,
        activeLayerId = _this$getState4.activeLayerId,
        sorting = _this$getState4.sorting;

      // Always have to have at least one column selected - don't allow setting this empty.
      if (value && value.length) {
        visibleColumnsSettings.visibleColumns = value;
      }
      var newState = {
        visibleColumnsSettings: visibleColumnsSettings,
        sorting: sorting
      };
      if (!value.includes(sorting === null || sorting === void 0 ? void 0 : sorting.columnKey)) {
        newState.sorting = this.determineSortingColumn(activeLayerId);
      }
      this.updateState(newState);
    }
  }, {
    key: "toggleFeature",
    value: function toggleFeature(featureId) {
      this.selectionService.toggleFeatureSelection(this.getState().activeLayerId, featureId);
    }
  }, {
    key: "isFlyoutOpen",
    value: function isFlyoutOpen() {
      return this.getState().flyoutOpen;
    }
  }, {
    key: "openFlyout",
    value: function openFlyout() {
      if (this.flyoutController) {
        this.closeFlyout();
        return;
      }
      var _this$getState5 = this.getState(),
        activeLayerId = _this$getState5.activeLayerId,
        activeLayerFeatures = _this$getState5.activeLayerFeatures,
        visibleColumnsSettings = _this$getState5.visibleColumnsSettings,
        selectByPropertiesFilter = _this$getState5.selectByPropertiesFilter,
        selectByPropertiesFeatureTypes = _this$getState5.selectByPropertiesFeatureTypes;
      var newState = {
        flyoutOpen: true,
        activeLayerFeatures: activeLayerFeatures,
        visibleColumnsSettings: visibleColumnsSettings,
        selectByPropertiesFilter: selectByPropertiesFilter,
        selectByPropertiesFeatureTypes: selectByPropertiesFeatureTypes,
        sorting: this.determineSortingColumn(activeLayerId)
      };
      if (!activeLayerFeatures) {
        // not empty features, but missing completely
        // empty should mean there is no features on viewport to list
        var newActiveLayerFeatures = this.getFeaturesByLayerId(activeLayerId);
        newState.activeLayerFeatures = newActiveLayerFeatures;
        newState.selectedFeatureIds = newActiveLayerFeatures && newActiveLayerFeatures.length ? this.getSelectedFeatureIdsByLayerId(activeLayerId) : null;
        newState.visibleColumnsSettings = this.createVisibleColumnsSettings(activeLayerId);
        newState.selectByPropertiesFilter = {};
        newState.selectByPropertiesFeatureTypes = this.createSelectByPropertiesFeatureTypes(newState.visibleColumnsSettings);
      }
      this.updateState(newState);
      this.flyoutController = showFeatureDataFlyout(this.getState(), this.getController());
    }
  }, {
    key: "openSelectByPropertiesPopup",
    value: function openSelectByPropertiesPopup() {
      if (this.selectByPropertiespopupController) {
        this.closeSelectByPropertiesPopup();
        return;
      }
      this.selectByPropertiespopupController = showSelectByPropertiesPopup(this.getState(), this.getController());
    }
  }, {
    key: "closeSelectByPropertiesPopup",
    value: function closeSelectByPropertiesPopup() {
      if (this.selectByPropertiespopupController) {
        this.selectByPropertiespopupController.close();
        this.selectByPropertiespopupController = null;
      }
    }
  }, {
    key: "openExportDataPopup",
    value: function openExportDataPopup() {
      if (this.exportDataPopupController) {
        this.closeExportDataPopup();
        return;
      }
      this.exportDataPopupController = showExportDataPopup(this.getState(), this.getController());
    }
  }, {
    key: "closeExportDataPopup",
    value: function closeExportDataPopup() {
      if (this.exportDataPopupController) {
        this.exportDataPopupController.close();
        this.exportDataPopupController = null;
      }
    }
  }, {
    key: "createVisibleColumnsSettings",
    value: function createVisibleColumnsSettings(newActiveLayerId) {
      var _allColumns;
      var _this$getState6 = this.getState(),
        activeLayerId = _this$getState6.activeLayerId,
        visibleColumnsSettings = _this$getState6.visibleColumnsSettings;
      var activeLayerChanged = activeLayerId && newActiveLayerId && activeLayerId !== newActiveLayerId;
      if (!activeLayerChanged && visibleColumnsSettings) {
        return visibleColumnsSettings;
      }
      var activeLayer = this.mapModule.getSandbox().findMapLayerFromSelectedMapLayers(newActiveLayerId) || null;
      var activeLayerProperties = (activeLayer === null || activeLayer === void 0 ? void 0 : activeLayer.getProperties()) || null;
      var allColumns = activeLayerProperties === null || activeLayerProperties === void 0 ? void 0 : activeLayerProperties.map(function (property) {
        return property.name;
      });

      // for some reason no properties for layer -> resort to features as last fallback.
      if (!((_allColumns = allColumns) !== null && _allColumns !== void 0 && _allColumns.length)) {
        var features = this.getFeaturesByLayerId(newActiveLayerId);
        if (features !== null && features !== void 0 && features.length) {
          var _features$;
          allColumns = Object.keys((_features$ = features[0]) === null || _features$ === void 0 ? void 0 : _features$.properties) || [];
        }
      }
      var activeLayerPropertyLabels = (activeLayer === null || activeLayer === void 0 ? void 0 : activeLayer.getPropertyLabels()) || null;
      var activeLayerPropertyTypes = (activeLayer === null || activeLayer === void 0 ? void 0 : activeLayer.getPropertyTypes()) || null;
      var newVisibleColumns = activeLayerChanged ? [].concat(allColumns) : visibleColumnsSettings !== null && visibleColumnsSettings !== void 0 && visibleColumnsSettings.visibleColumns ? visibleColumnsSettings.visibleColumns : [].concat(allColumns);
      if (!allColumns.includes(ID_FIELD)) {
        allColumns = [ID_FIELD].concat(allColumns);
      }
      if (activeLayerPropertyLabels && !activeLayerPropertyLabels[ID_FIELD]) {
        activeLayerPropertyLabels[ID_FIELD] = ID_FIELD_LABEL;
      }
      return {
        allColumns: allColumns,
        visibleColumns: newVisibleColumns,
        activeLayerPropertyLabels: activeLayerPropertyLabels,
        activeLayerPropertyTypes: activeLayerPropertyTypes
      };
    }
  }, {
    key: "closeFlyout",
    value: function closeFlyout(resetLayers) {
      if (this.flyoutController) {
        this.flyoutController.close();
        this.flyoutController = null;
      }
      this.closeSelectByPropertiesPopup();
      this.closeExportDataPopup();
      this.updateState({
        flyoutOpen: false,
        layers: resetLayers ? null : this.getState().layers
      });
    }
  }, {
    key: "updateFlyout",
    value: function updateFlyout() {
      if (this.flyoutController) {
        this.flyoutController.update(this.getState());
      }
      if (this.selectByPropertiespopupController) {
        this.selectByPropertiespopupController.update(this.getState());
      }
      if (this.exportDataPopupController) {
        this.exportDataPopupController.update(this.getState());
      }
    }
  }, {
    key: "updateFilter",
    value: function updateFilter(selectByPropertiesFilter) {
      this.updateState({
        selectByPropertiesFilter: selectByPropertiesFilter
      });
    }
  }, {
    key: "resetFilter",
    value: function resetFilter() {
      this.updateState({
        selectByPropertiesFilter: {}
      });
    }
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      var _this$getState7 = this.getState(),
        selectByPropertiesFilter = _this$getState7.selectByPropertiesFilter,
        selectByPropertiesFeatureTypes = _this$getState7.selectByPropertiesFeatureTypes,
        activeLayerFeatures = _this$getState7.activeLayerFeatures,
        activeLayerId = _this$getState7.activeLayerId;
      var cleaned = cleanFilter(selectByPropertiesFilter, selectByPropertiesFeatureTypes);
      var selectedFeatures = filterFeaturesByPropertyFilter(cleaned, activeLayerFeatures);
      var selectedFeatureIds = (selectedFeatures === null || selectedFeatures === void 0 ? void 0 : selectedFeatures.map(function (feature) {
        return feature.id;
      })) || null;
      if (selectedFeatureIds) {
        this.selectionService.setSelectedFeatureIds(activeLayerId, selectedFeatureIds);
      }
    }
  }, {
    key: "createSelectByPropertiesFeatureTypes",
    value: function createSelectByPropertiesFeatureTypes(visibleColumnsSettings) {
      if (!visibleColumnsSettings) {
        return {};
      }
      var activeLayerPropertyTypes = visibleColumnsSettings.activeLayerPropertyTypes;
      if (!activeLayerPropertyTypes) {
        return null;
      }
      ;
      var featureProperties = Object.keys(activeLayerPropertyTypes).map(function (key) {
        return {
          name: key,
          type: activeLayerPropertyTypes[key]
        };
      });
      return featureProperties;
    }
  }, {
    key: "determineActiveLayerId",
    value: function determineActiveLayerId(featureDataLayers) {
      var _this2 = this;
      var currentLayer = featureDataLayers === null || featureDataLayers === void 0 ? void 0 : featureDataLayers.find(function (layer) {
        return layer.getId() === _this2.getState().activeLayerId;
      });
      if (!currentLayer && featureDataLayers !== null && featureDataLayers !== void 0 && featureDataLayers.length) {
        currentLayer = featureDataLayers[0];
      }
      return currentLayer ? currentLayer.getId() : null;
    }
  }, {
    key: "determineSortingColumn",
    value: function determineSortingColumn(newActiveLayerId) {
      var _visibleColumnsSettin;
      var _this$getState8 = this.getState(),
        activeLayerId = _this$getState8.activeLayerId,
        visibleColumnsSettings = _this$getState8.visibleColumnsSettings,
        sorting = _this$getState8.sorting;
      var activeLayerChanged = newActiveLayerId !== activeLayerId;

      // Same layer and the previous sorting field is still visible -> use the old
      if (!activeLayerChanged && sorting !== null && sorting !== void 0 && sorting.columnKey && visibleColumnsSettings !== null && visibleColumnsSettings !== void 0 && (_visibleColumnsSettin = visibleColumnsSettings.visibleColumns) !== null && _visibleColumnsSettin !== void 0 && _visibleColumnsSettin.includes(sorting === null || sorting === void 0 ? void 0 : sorting.columnKey)) {
        return sorting;
      }

      // otherwise this needs to be recreated.
      return this.resetSortingColumn(newActiveLayerId);
    }
  }, {
    key: "resetSortingColumn",
    value: function resetSortingColumn(newActiveLayerId) {
      var newVisibleColumnsSettings = this.createVisibleColumnsSettings(newActiveLayerId);
      var defaultSortingColumn = (newVisibleColumnsSettings === null || newVisibleColumnsSettings === void 0 ? void 0 : newVisibleColumnsSettings.visibleColumns[0]) || null;
      var sortedInfo = {
        order: 'ascend',
        columnKey: defaultSortingColumn
      };
      return sortedInfo;
    }
  }, {
    key: "sendExportDataForm",
    value: function sendExportDataForm(data) {
      var format = data.format,
        columns = data.columns,
        delimiter = data.delimiter,
        exportOnlySelected = data.exportOnlySelected,
        exportDataSource = data.exportDataSource,
        exportMetadataLink = data.exportMetadataLink;
      var params = {
        format: format,
        columns: columns,
        delimiter: delimiter
      };
      var _this$getState9 = this.getState(),
        layers = _this$getState9.layers,
        activeLayerId = _this$getState9.activeLayerId;
      var layer = layers === null || layers === void 0 ? void 0 : layers.find(function (layer) {
        return layer.getId() === activeLayerId;
      });
      params.filename = layer.getName();
      params.data = this.gatherExportData(exportOnlySelected, columns === COLUMN_SELECTION.opened);
      params.additionalData = this.gatherAdditionalInfo(exportDataSource, exportMetadataLink, layer);
      if (format === FILETYPES.excel) {
        this.exportAsExcel(params);
        return;
      }
      this.exportAsCsv(params);
    }
  }, {
    key: "exportAsExcel",
    value: function exportAsExcel(params) {
      params.data = JSON.stringify(params.data);
      params.additionalData = JSON.stringify(params.additionalData);
      var contentLength = 0;
      Object.keys(params).forEach(function (key) {
        var _params$key;
        if ((_params$key = params[key]) !== null && _params$key !== void 0 && _params$key.length) {
          contentLength += params[key].length;
        }
      });
      if (contentLength >= EXPORT_FEATUREDATA_EXCEL_MAX_LENGTH) {
        Messaging.error(Oskari.getMsg(FEATUREDATA_BUNDLE_ID, 'exportDataPopup.datasetTooLargeForExcel'));
        return;
      }
      var payload = new URLSearchParams();
      Object.keys(params).forEach(function (key) {
        return payload.append(key, params[key]);
      });
      var extension = '.xlsx';
      this.sendData(payload, params.filename + extension);
    }
  }, {
    key: "exportAsCsv",
    value: function exportAsCsv(params) {
      if ((params === null || params === void 0 ? void 0 : params.delimiter) === SEPARATORS.tabulator) {
        params.delimiter = '\t';
      }
      var replacer = function replacer(value) {
        return !value ? '' : value;
      };
      var headers = params.data.splice(0, 1)[0];
      var headerRow = headers.join(params.delimiter);
      var dataRows = params.data.map(function (values) {
        return values.map(function (value) {
          return replacer(value);
        }).join(params.delimiter);
      }).join('\r\n');
      var additionalDataRows = params.additionalData.map(function (value) {
        // TODO: case metadata - we should dig up the metadata service url from someplace
        // not currently available in fe
        return [value.name, value.value].join(params.delimiter);
      }).join('\r\n');
      var emptyRow = null;
      var csv = [headerRow, dataRows, emptyRow, additionalDataRows].join('\r\n');
      var link = document.createElement('a');
      link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
      link.setAttribute('download', params.filename + '.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, {
    key: "sendData",
    value: function sendData(payload, filename) {
      try {
        fetch(Oskari.urls.getRoute(EXPORT_FEATUREDATA_ROUTE), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Accept': 'application/json'
          },
          body: payload
        }).then(function (response) {
          if (!response.ok) {
            throw new Error(response.statusText);
          }
          return response.blob();
        }).then(function (blob) {
          if (blob != null) {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          }
        });
      } catch (e) {
        Messaging.error(Oskari.getMsg(FEATUREDATA_BUNDLE_ID, 'featureData.exportDataPopup.exportFailed'));
      }
    }
  }, {
    key: "getDataSourceFromActiveLayer",
    value: function getDataSourceFromActiveLayer(layer) {
      return layer && layer.getSource && typeof layer.getSource === 'function' && layer.getSource() ? layer.getSource() : layer.getOrganizationName();
    }
  }, {
    key: "gatherExportData",
    value: function gatherExportData(onlySelectedFeatures, onlySelectedColumns) {
      var _this$getState10 = this.getState(),
        visibleColumnsSettings = _this$getState10.visibleColumnsSettings,
        activeLayerFeatures = _this$getState10.activeLayerFeatures,
        selectedFeatureIds = _this$getState10.selectedFeatureIds;
      var columns = onlySelectedColumns ? visibleColumnsSettings.visibleColumns : visibleColumnsSettings.allColumns;
      var featureValues = activeLayerFeatures.filter(function (feature) {
        return onlySelectedFeatures ? selectedFeatureIds.includes(feature.id) : true;
      }).map(function (feature) {
        return columns.map(function (column) {
          return feature === null || feature === void 0 ? void 0 : feature.properties[column];
        });
      });
      return [].concat([columns]).concat(featureValues);
    }
  }, {
    key: "gatherAdditionalInfo",
    value: function gatherAdditionalInfo(exportDataSource, exportMetadaLink, layer) {
      var additionalInfo = [];
      if (exportDataSource) {
        additionalInfo.push({
          type: 'datasource',
          name: Oskari.getMsg(FEATUREDATA_BUNDLE_ID, 'exportDataPopup.additionalSettings.dataSource'),
          value: this.getDataSourceFromActiveLayer(layer)
        });
      }
      additionalInfo.push({
        type: 'layerName',
        name: Oskari.getMsg(FEATUREDATA_BUNDLE_ID, 'exportDataPopup.additionalSettings.layerName'),
        value: layer.getName()
      });
      if (exportMetadaLink) {
        additionalInfo.push({
          type: 'metadata',
          name: Oskari.getMsg(FEATUREDATA_BUNDLE_ID, 'exportDataPopup.additionalSettings.metadataLink'),
          value: layer.getMetadataIdentifier()
        });
      }
      return additionalInfo;
    }
  }]);
}(StateHandler);
var wrapped = controllerMixin(FeatureDataPluginUIHandler, ['isFlyoutOpen', 'openFlyout', 'closeFlyout', 'setActiveTab', 'toggleShowSelectedFirst', 'toggleShowCompressed', 'updateStateAfterMapEvent', 'updateSelectedFeatures', 'updateSorting', 'updateLoadingStatus', 'updateVisibleColumns', 'toggleFeature', 'openSelectByPropertiesPopup', 'closeSelectByPropertiesPopup', 'openExportDataPopup', 'closeExportDataPopup', 'sendExportDataForm', 'updateFilter', 'resetFilter', 'applyFilter']);
export { wrapped as FeatureDataPluginHandler };